import R from 'ramda';
import { Observable } from 'rxjs/Observable';
import { appError } from '../app/actions';
import { IMAGE_SERVER_URL } from '../../browser/app/constants';

// Get properties

export const onPropertiesPresence = (snap) => {
  const properties = snap.val();
  return {
    type: 'ON_PROPERTIES_PRESENCE',
    payload: { properties },
  };
};

// Get my properties

export const onMyPropertiesPresence = (snap) => {
  const myProperties = snap.val();
  return {
    type: 'ON_MY_PROPERTIES_PRESENCE',
    payload: { myProperties },
  };
};

// Get property

export const onPropertyDetailsPresence = (snap) => {
  const propertyDetails = snap.val();
  return {
    type: 'ON_PROPERTY_DETAILS_PRESENCE',
    payload: { propertyDetails },
  };
};

// Search properties

export const searchProperties = searchVariables => ({
  type: 'SEARCH_PROPERTIES',
  payload: { searchVariables },
});

// Create property

export const createPropertyWithImages = (newProperty, newPropertyImages) => ({
  type: 'CREATE_PROPERTY_WITH_IMAGES',
  payload: { newProperty, newPropertyImages },
});

export const createPropertyImages = (newProperty, newPropertyImages, imageDownloadUrls) => ({
  type: 'CREATE_PROPERTY_IMAGES',
  payload: { newProperty, newPropertyImages, imageDownloadUrls },
});

export const createPropertyImagesParseResponse =
  (newProperty, newPropertyImages, imageDownloadUrls, response) => ({
    type: 'CREATE_PROPERTY_IMAGES_PARSE_RESPONSE',
    payload: { newProperty, newPropertyImages, imageDownloadUrls, response },
  });

export const createProperty = (newProperty, imageDownloadUrls) => ({
  type: 'CREATE_PROPERTY',
  payload: { newProperty, imageDownloadUrls },
});

export const createPropertyWithImagesDone = () => ({
  type: 'CREATE_PROPERTY_WITH_IMAGES_DONE',
});

const createPropertyWithImagesEpic = (
  action$,
  { firebase },
) => {
  const createPropertyWithImagesEpic = (newProperty, newPropertyImages) => {
    newProperty.id = firebase.child('properties').push().key;
    return () => createPropertyImages(newProperty, newPropertyImages, []);
  };

  return action$
    .filter(action => action.type === 'CREATE_PROPERTY_WITH_IMAGES')
    .map((action) => {
      const { newProperty, newPropertyImages } = action.payload;
      return createPropertyWithImagesEpic(newProperty, newPropertyImages);
    });
};

const createPropertyEpic = (
  action$,
  { firebase },
) => {
  const createPropertyToFirebase = (newProperty, imageDownloadUrls) => {
    newProperty.imageDownloadUrls = imageDownloadUrls;
    const promise = firebase.child(`properties/${newProperty.id}`)
      .set(newProperty);
    return Observable.from(promise)
      .mapTo(createPropertyWithImagesDone())
      .catch(error => Observable.of(appError(error)));
  };

  return action$
    .filter(action => action.type === 'CREATE_PROPERTY')
    .mergeMap((action) => {
      const { newProperty, imageDownloadUrls } = action.payload;
      return createPropertyToFirebase(newProperty, imageDownloadUrls);
    });
};

const createPropertyImageEpic = (
  action$,
) => {
  const createPropertyImagesToImageServer = (newProperty, newPropertyImages, imageDownloadUrls) => {
    /* eslint-disable no-undef */
    const postUrl = `${IMAGE_SERVER_URL}/photos/`;
    const fd = new FormData();
    fd.set('url', newPropertyImages[0].value);
    const config = { method: 'POST', body: fd };
    const promise = fetch(postUrl, config);
    return Observable.from(promise)
      .map(response =>
        createPropertyImagesParseResponse(newProperty, newPropertyImages,
          imageDownloadUrls, response))
      .catch(error => Observable.of(appError(error)));
  };

  return action$
    .filter(action => action.type === 'CREATE_PROPERTY_IMAGES')
    .mergeMap((action) => {
      const { newProperty, newPropertyImages, imageDownloadUrls } = action.payload;
      return createPropertyImagesToImageServer(newProperty, newPropertyImages, imageDownloadUrls);
    });
};

const createPropertyImageParseResponseEpic = (
  action$,
) => {
  const parseResponseAndSaveUrl = (newProperty, newPropertyImages, imageDownloadUrls, response) => {
    const promise = response.json();
    return Observable.from(promise)
      .map((responseObject) => {
        imageDownloadUrls.push({
          url: IMAGE_SERVER_URL + responseObject.url,
          thumbnail: IMAGE_SERVER_URL + responseObject.thumbnail,
        });
        if (newPropertyImages.length === 1) {
          return createProperty(newProperty, imageDownloadUrls);
        }
        return createPropertyImages(newProperty, R.drop(1, newPropertyImages), imageDownloadUrls);
      })
      .catch(error => Observable.of(appError(error)));
  };

  return action$
    .filter(action => action.type === 'CREATE_PROPERTY_IMAGES_PARSE_RESPONSE')
    .mergeMap((action) => {
      const { newProperty, newPropertyImages, imageDownloadUrls, response } = action.payload;
      return parseResponseAndSaveUrl(newProperty, newPropertyImages, imageDownloadUrls, response);
    });
};

// Update property

export const updatePropertyWithImages = (updatedProperty, newPropertyImages) => ({
  type: 'UPDATE_PROPERTY_WITH_IMAGES',
  payload: { updatedProperty, newPropertyImages },
});

export const createUpdatedPropertyImages =
  (updatedProperty, newPropertyImages, imageDownloadUrls) => ({
    type: 'UPDATE_PROPERTY_IMAGES',
    payload: { updatedProperty, newPropertyImages, imageDownloadUrls },
  });

export const createUpdatedPropertyImagesParseResponse =
  (updatedProperty, newPropertyImages, imageDownloadUrls, response) => ({
    type: 'UPDATE_PROPERTY_IMAGES_PARSE_RESPONSE',
    payload: { updatedProperty, newPropertyImages, imageDownloadUrls, response },
  });

export const updateProperty = (updatedProperty, imageDownloadUrls) => ({
  type: 'UPDATE_PROPERTY',
  payload: { updatedProperty, imageDownloadUrls },
});

export const updatePropertyWithImagesDone = () => ({
  type: 'UPDATE_PROPERTY_WITH_IMAGES_DONE',
});

const updatePropertyWithImagesEpic = (
  action$,
) => {
  const updatePropertyWithImagesEpic = (updatedProperty, newPropertyImages) => {
    if (newPropertyImages.length === 0) {
      return () => updateProperty(updatedProperty, newPropertyImages, []);
    }
    return () => createUpdatedPropertyImages(updatedProperty, newPropertyImages, []);
  };

  return action$
    .filter(action => action.type === 'UPDATE_PROPERTY_WITH_IMAGES')
    .map((action) => {
      const { updatedProperty, newPropertyImages } = action.payload;
      return updatePropertyWithImagesEpic(updatedProperty, newPropertyImages);
    });
};

const updatePropertyEpic = (
  action$,
  { firebase },
) => {
  const updatePropertyToFirebase = (updatedProperty, imageDownloadUrls) => {
    for (let i = 0; i < imageDownloadUrls.length; i += 1) {
      updatedProperty.imageDownloadUrls.push(imageDownloadUrls[i]);
    }

    const promise = firebase.child(`properties/${updatedProperty.id}`)
      .update(updatedProperty);
    return Observable.from(promise)
      .mapTo(updatePropertyWithImagesDone())
      .catch(error => Observable.of(appError(error)));
  };

  return action$
    .filter(action => action.type === 'UPDATE_PROPERTY')
    .mergeMap((action) => {
      const { updatedProperty, imageDownloadUrls } = action.payload;
      return updatePropertyToFirebase(updatedProperty, imageDownloadUrls);
    });
};

const createUpdatedPropertyImageEpic = (
  action$,
) => {
  const createUpdatedPropertyImagesToFirebase =
  (updatedProperty, newPropertyImages, imageDownloadUrls) => {
    /* eslint-disable no-undef */
    const postUrl = `${IMAGE_SERVER_URL}/photos/`;
    const fd = new FormData();
    fd.set('url', newPropertyImages[0].value);
    const config = { method: 'POST', body: fd };
    const promise = fetch(postUrl, config);
    return Observable.from(promise)
      .map(response =>
        createUpdatedPropertyImagesParseResponse(updatedProperty, newPropertyImages,
          imageDownloadUrls, response))
      .catch(error => Observable.of(appError(error)));
  };

  return action$
    .filter(action => action.type === 'UPDATE_PROPERTY_IMAGES')
    .mergeMap((action) => {
      const { updatedProperty, newPropertyImages, imageDownloadUrls } = action.payload;
      return createUpdatedPropertyImagesToFirebase(updatedProperty,
        newPropertyImages, imageDownloadUrls);
    });
};

const createUpdatedPropertyImageResponseEpic = (
  action$,
) => {
  const parseResponseAndSaveUrl = (updatedProperty, newPropertyImages,
    imageDownloadUrls, response) => {
    const promise = response.json();
    return Observable.from(promise)
      .map((responseObject) => {
        imageDownloadUrls.push({
          url: IMAGE_SERVER_URL + responseObject.url,
          thumbnail: IMAGE_SERVER_URL + responseObject.thumbnail,
        });
        if (newPropertyImages.length === 1) {
          return updateProperty(updatedProperty, imageDownloadUrls);
        }
        return createUpdatedPropertyImages(updatedProperty,
          R.drop(1, newPropertyImages), imageDownloadUrls);
      })
      .catch(error => Observable.of(appError(error)));
  };

  return action$
    .filter(action => action.type === 'UPDATE_PROPERTY_IMAGES_PARSE_RESPONSE')
    .mergeMap((action) => {
      const { updatedProperty, newPropertyImages, imageDownloadUrls, response } = action.payload;
      return parseResponseAndSaveUrl(updatedProperty, newPropertyImages,
        imageDownloadUrls, response);
    });
};

// Delete property

export const deletePropertyWithImages = (propertyId, numberOfImages) => ({
  type: 'DELETE_PROPERTY_WITH_IMAGES',
  payload: { propertyId, numberOfImages },
});

export const deletePropertyImages = (propertyId, numberOfImages) => ({
  type: 'DELETE_PROPERTY_IMAGES',
  payload: { propertyId, numberOfImages },
});

export const deletePropertyWithImagesDone = () => ({
  type: 'DELETE_PROPERTY_WITH_IMAGES_DONE',
});

const deletePropertyImagesEpic = (
  action$,
  { firebaseStorage },
) => {
  const deletePropertyFromFirebase = (propertyId, numberOfImages) => {
    const storageRef = firebaseStorage().ref();
    const imageRef = storageRef.child(`images/${propertyId}_${numberOfImages - 1}.jpg`);
    const promise = imageRef.delete();
    return Observable.from(promise)
      .mapTo(() => {
        if (numberOfImages === 1) {
          return deletePropertyWithImagesDone();
        }
        return deletePropertyImages(propertyId, numberOfImages - 1);
      })
      .catch(error => Observable.of(appError(error)));
  };

  return action$
    .filter(action => action.type === 'DELETE_PROPERTY_IMAGES')
    .mergeMap((action) => {
      const { propertyId, numberOfImages } = action.payload;
      return deletePropertyFromFirebase(propertyId, numberOfImages);
    });
};

const deletePropertyEpic = (
  action$,
  { firebase },
) => {
  const deletePropertyFromFirebase = (propertyId) => { // , numberOfImages) => {
    const promise = firebase.child(`properties/${propertyId}`).remove();
    return Observable.from(promise)
      .mapTo(deletePropertyWithImagesDone()/* deletePropertyImages(propertyId, numberOfImages) */)
      .catch(error => Observable.of(appError(error)));
  };

  return action$
    .filter(action => action.type === 'DELETE_PROPERTY_WITH_IMAGES')
    .mergeMap((action) => {
      const { propertyId, numberOfImages } = action.payload;
      return deletePropertyFromFirebase(propertyId, numberOfImages);
    });
};

export const epics = [
  createPropertyWithImagesEpic,
  createPropertyEpic,
  createPropertyImageEpic,
  createPropertyImageParseResponseEpic,
  updatePropertyWithImagesEpic,
  updatePropertyEpic,
  createUpdatedPropertyImageEpic,
  createUpdatedPropertyImageResponseEpic,
  deletePropertyImagesEpic,
  deletePropertyEpic,
];



// WEBPACK FOOTER //
// ./src/common/properties/actions.js